import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'transportation-highlight-wrapper',
  templateUrl: './transportation-highlight-wrapper.component.html',
  styleUrls: ['./transportation-highlight-wrapper.component.scss']
})
export class TransportationHighlightWrapperComponent implements OnInit {

  @Input() PERMISSIONS = [];
  @Input() TITLES = [];
  @Input() APIS = [];
  @Input() TEXTS = [];
  @Input() TOTAL: any = '';
  @Input() COLUMNSIZE = 6;
  deviceWidth = window.innerWidth;

  constructor() { }

  ngOnInit() {
  }

}
